
export enum LanguageEnum {
  en = 'en',
  ptBR = 'pt-BR',
  es419 = 'es-419',
};

export enum ThemeEnum {
  auto = 'auto',
  light = 'light',
  dark = 'dark',
};

export interface ISettingsModel {
  version: number,
  language: LanguageEnum,
  theme: ThemeEnum,
}

export class Settings implements ISettingsModel {
  version: number;
  language: LanguageEnum;
  theme: ThemeEnum;

  constructor(data: ISettingsModel) {
    this.version = data.version;
    this.language = data.language;
    this.theme = data.theme;
  }
}


export interface IAdvancedTrainerSettingTerms {
  version: number;
  terms: string;
}

export interface IAdvancedTrainerSettingAnamnesis {
  version: number;
  questions: string[];
}

export interface IAdvancedTrainerSettingEvaluation {
  version: number;
  questions: string[];
}

export interface IAdvancedTrainerSettingServiceMetrics {
  version: number;
  plans: number;
  videoReviews: number;
  questions: number;
}


export enum ConfigIdx {
  Terms = 1,
  Anamnesis = 2,
  Evaluation = 3,
  ServiceMetrics = 4,
}
export interface TrainerConfigurationModel<T> {
  id: ConfigIdx,
  config: T,
}
